<template>
  <div>
    <section class="footers sections sections--bg">
      <v-container>
        <v-row>
          <v-col cols="12" sm="3">
            <div class="footers-- mb-8">
              <div class="d-flex mb-10">
                <div class="pr-5">
                  <v-img
                    max-width="70"
                    lazy-src="@/assets/img/logo2.png"
                    src="@/assets/img/logo2.png"
                  ></v-img>
                </div>

                <v-img
                  max-width="60"
                  lazy-src="@/assets/img/logo.png"
                  src="@/assets/img/logo.png"
                ></v-img>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <div class="footers--line">
              <p class="text-uppercase font-weight-bold">Tentang Kami</p>
            </div>
            <ul class="footers--list">
              <li class="text-capitalize pa-3">
                Pemerintahan
              </li>
              <li class="text-capitalize pa-3">
                Cerita Museum Nasional
              </li>
            </ul>
          </v-col>
          <v-col cols="12" sm="3">
            <div class="footers--line">
              <p class="text-uppercase font-weight-bold">Kunjungi</p>
            </div>
            <ul class="footers--list">
              <li class="text-capitalize pa-3">
                Peta Museum
              </li>
              <li class="text-capitalize pa-3">
                Pameran dan Kegiatan
              </li>
            </ul>
          </v-col>
          <v-col cols="12" sm="3">
            <div class="footers--line">
              <p class="text-uppercase font-weight-bold">Pameran Daring</p>
            </div>
            <ul class="footers--list">
              <li class="text-capitalize pa-3">
                Pameran
              </li>
              <li class="text-capitalize pa-3">
                Virtual Tour
              </li>
            </ul>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-uppercase font-weight-bold">Kontak Kami</v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="3" class="footers--sosmed">
            <v-btn
              v-for="(social, i) in socials"
              :key="i"
              class="footers--sosmed__icon"
              fab
              icon
            >
              <v-icon>{{ social.icon }}</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            Jl. Medan Merdeka Barat No.12, Kota Jakarta Pusat, Daerah Khusus
            Ibukota Jakarta, Indonesia <br> Telepon: +62 21 3868172
          </v-col>
        </v-row>
      </v-container>
    </section>
    <v-footer padless class="footers--copyright">
      <v-col class="text-center" cols="12">
        Copyrights &copy; {{ new Date().getFullYear() }}. All Rights Reserved
      </v-col>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      data: ["home", "about"],
      info: ["Gallery 1", "Gllery 2"],
      socials: [
        {
          icon: "mdi-facebook"
        },
        {
          icon: "mdi-twitter"
        },
        {
          icon: "mdi-instagram"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
